import React from 'react'
import { LgySection } from 'app/components/util/lgy-section/LgySection'
import LgyField from 'app/components/util/lgy-field/LgyField'
import { getUserTypesFromAffiliations, accountStatusStringFromCode, getUserAffiliation } from 'app/utils/userUtils'
import { formatDateToDisplayString } from 'app/utils/dateTimeUtils'
import { replacePercentEscapedSpaces } from 'app/utils/userUtils'

const OverviewPage = ({ user }) => <LgySection header={`Account Overview for ${replacePercentEscapedSpaces(user.firstName).toUpperCase()}  ${replacePercentEscapedSpaces(user.lastName ? user.lastName :'').toUpperCase()}`}>
  <LgyField label='User ID' value={user.portalId} />
  <LgyField label='User Affiliation' value={getUserAffiliation(user)} />
  <LgyField label='SSN' value={user.ssn ? `***-**-${user.ssn}` : `${user.ssn}`} />
  {user.isAffiliate && <LgyField label='User Type(s)' value={getUserTypesFromAffiliations(user.affiliations)} />}
  <LgyField label='Active' value={user.active ? 'Yes' : 'No'} />
  <LgyField label='Account Status' value={accountStatusStringFromCode(user.accountStatusCode)} />
  <LgyField label='Last Login' value={user.lastLoginDate
    ? formatDateToDisplayString(new Date(user.lastLoginDate))
    : user.id
      ? 'Hasn\'t logged in before'
      : 'Loading...'} />
  {!!user.userType && (
    <LgyField label='Account Type' value={user.userType} />
  )}
</LgySection>

export default OverviewPage